const CheckBox = ({
  left_title,
  noMargin,
  handle,
  name,
  text,
  value,
  title,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        // 1. Moved the margin up here so it doesn't push the toggle off-center
        marginBottom: !noMargin ? "10px" : "0px",
      }}
    >
      {/* Conditionally render the left title */}
      {left_title && (
        <div
          style={{
            paddingRight: "10px",
            display: "flex",
            alignItems: "center", // Keeps text perfectly centered
          }}
          className="text_medium"
        >
          {left_title}
        </div>
      )}

      {/* The Toggle Switch */}
      <div style={{ width: "40px", display: "flex", alignItems: "center" }}>
        <label
          className="switch"
          style={{ margin: 0, display: "block" }} // 2. Removed default label margins
        >
          <input
            type="checkbox"
            onChange={handle}
            name={name || text}
            checked={value}
            id={text}
          />
          <span className="slider_check round" data-mapid="clickToggle"></span>
        </label>
      </div>

      {/* Conditionally render the right title */}
      {title && (
        <div
          style={{
            paddingLeft: "10px",
            display: "flex",
            alignItems: "center", // 3. Ensures the "Save!" badge and text align perfectly
          }}
          className="text_medium"
        >
          {title}
        </div>
      )}
    </div>
  );
};

export default CheckBox;
